import { StorageBoxType } from "../models/storage.box.type";
import BaseService from "./_base.service";

const endpoint = "storage-box-types";

const StorageBoxTypeService = {
  ...BaseService<StorageBoxType>({ endpoint }),
};

export default StorageBoxTypeService;
